import { Component, Input, OnInit } from '@angular/core';
import { EntidadesService } from '@core/services/entidades.service';
import { TransferItem } from 'ng-zorro-antd/transfer';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-lista-transfer',
  templateUrl: './lista-transfer.component.html',
  styleUrls: ['./lista-transfer.component.css']
})
export class ListaTransferComponent implements OnInit {

  @Input() idParams!: number;

  list: TransferItem[] = [];

  constructor(
    private service: EntidadesService
  ) { }

  ngOnInit() {
    this.carregarListaTransfer();
  }

  carregarListaTransfer() {
    forkJoin([
      this.service.entidadesSemGrupoEconomico(),
      this.service.listarEntidadesVinculadasGrupoEconomico(this.idParams)
    ]).subscribe(([todasEntidades, vinculadas]) => {
      const todasEntidadesDesteGrupo = todasEntidades.filter((item: any) => {
        return item.idGrupoEconomico === Number(this.idParams) || item.idGrupoEconomico == null;
      });

      this.list = todasEntidadesDesteGrupo.map((item: any) => {
        const isVinculada = vinculadas?.some((v: any) => v.id === item.id);
        return {
          key: String(item.id),
          title: item.nome ? item.nome.trim() : '',
          value: item.id,
          direction: isVinculada ? 'right' : undefined
        };
      });
    });
  }

  public filterOption(inputValue: string, item: any): boolean {
    return (item.title || '').toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  }

  change(ret: any): void {
    const adicionar = ret.from === 'left';
    ret.list.forEach((item: any) => {
      const objEnvio = {
        idGrupoEconomico: Number(this.idParams),
        idEntidade: item.value,
        adicionar: adicionar
      };

      this.service.editarEntidadesVinculadasGrupoEconomico(objEnvio).subscribe(() => {
        this.carregarListaTransfer();
      });
    });
  }
}
